import React from 'react';
import DatePicker from 'react-datepicker';
import { Tooltip } from 'reactstrap';
import language from '../../../assets/languages/language';
import App_data from '../../config/App_data';

const DashboardDateFilter = ({
  startDate = '',
  endDate = '',
  isDateHandleChange,
  resetDate,
  isTooltipToggle,
  tooltipOpen = false,
  content = '',
}) => {
  return (
    <div className='card margin_bottom_20'>
      <div className='card-block'>
        <div className='row dashboard-filter'>
          <div className='date-field align-self-center'>
            <div className='d-flex'>
              <div className='mr-1 min-width-35px text-md-right align-self-center'>
                <label className='margin_bottom_0'>{language.LC().FROM}</label>
              </div>
              <div className='align-self-center w-100 pr-1'>
                <div className='datepicker_wrap'>
                  <div className='ico_box'>
                    <img
                      src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                      alt=''
                      width='14'
                    />
                  </div>
                  <DatePicker
                    selected={startDate}
                    onChange={e => isDateHandleChange(e, 'startDate')}
                    placeholderText='Select date'
                    width='100%'
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='date-field align-self-center'>
            <div className='d-flex'>
              <div className='mr-1 min-width-35px text-md-center align-self-center'>
                <label className='margin_bottom_0'> {language.LC().TO}</label>
              </div>
              <div className='align-self-center w-100 pr-1'>
                <div className='datepicker_wrap'>
                  <div className='ico_box'>
                    <img
                      src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                      alt=''
                      width='14'
                    />
                  </div>
                  <DatePicker
                    placeholderText='Select date'
                    width='100%'
                    selected={endDate}
                    minDate={startDate}
                    onChange={e => isDateHandleChange(e, 'endDate')}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='mx-auto text-md-center align-self-center' id={'Tooltip-' + 3}>
            <button
              className={`btn btn-circle btn-refresh cursor-pointer ${
                !startDate || !endDate ? 'disabled' : ''
              }`}
              onClick={() => resetDate()}
            >
              <i className='fa fa-refresh' aria-hidden='true' />
              <Tooltip
                placement={'top'}
                isOpen={tooltipOpen}
                target={'Tooltip-' + 3}
                toggle={() => isTooltipToggle()}
              >
                <p className='tooltip_text'>{content}</p>
              </Tooltip>
              <span className='reset'>Reset</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardDateFilter;



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/DashboardDateFilter.jsx